import { ScrollView, StyleSheet, View } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { Button, Panel } from 'react95-native-rabbl';
import { AppText } from '@/components/AppText';
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import type { RootState } from '@/state/store';
import { useSelector } from 'react-redux';
import { CustomText, CustomTextStyles } from '@/components/CustomText';
import { Link } from 'expo-router';
import { RelativePathString, useRouter } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    paddingTop: 10,
    gap: 20,
    backgroundColor: 'transparent',
    alignItems: 'center',
  },
  panel: {
    padding: 20,
    gap: 20,
    alignItems: 'center',
  },
  buttonWrapper: {
    flexDirection: 'row',
  },
});

export default function WaitingApproval() {
  const community = useSelector((state: RootState) => state.user.creating_community);
  const router = useRouter();

  return (
    <BasicScrollView center={true}>
      <Meta title={"Awaiting approval"} />
            
      <Panel variant='raised' elevation={4}>
        <View style={styles.panel}>
          <AppText>Your Rabbl ({community.name}) is waiting approval. We'll send you an email. If you have any questions, you can <Link href="/contact" style={CustomTextStyles.link}>contact us</Link>.</AppText>
          <View style={styles.buttonWrapper}>
            <Button onPress={() => router.navigate('/rabbls')}>Back to Rabbl list</Button>
          </View>
        </View>
      </Panel>
      
      <Footer />
    </BasicScrollView>
  );
}
